<template>
    <div>
        <div class="col-lg-8 px-0 mt-4">
            <ul class="input-table">
                <li
                    class="d-flex justify-content-start"
                    v-if="items.length"
                    v-for="(item, index) in items"
                    :key="item.id"
                >
                    <div class="input-table-shadow">
                        <div class="d-flex row align-items-center">
                            <div class="col-6 pl-4 border-right">
                                <input type="text" placeholder="name" v-model="item.name">
                            </div>
                            <div class="col-6">
                                <input type="text" placeholder="amount" v-model="item.amount">
                            </div>
                        </div>
                    </div>
                    <div class="pl-2 d-flex align-items-center">
                        <core-icon
                            @click.native="clone(item)"
                            class="pointer"
                            :iconName="$t('general.clone')"
                            iconColor="#bdbdbd"
                        >
                            <icons-clone></icons-clone>
                        </core-icon>
                    </div>
                    <div class="pl-1 d-flex align-items-center">
                        <core-icon
                            @click.native="remove(index)"
                            class="pointer"
                            :iconName="$t('general.remove')"
                            iconColor="#bdbdbd"
                        >
                            <icons-delete></icons-delete>
                        </core-icon>
                    </div>
                </li>
            </ul>
        </div>
        <img
            class="ml-3 add-row"
            src="@/assets/svg/plus008CDD.svg"
            @click="add"
            :title="$t('general.add')"
        >
    </div>
</template>

<script>
import Services from '@/services/Services'
import Service from '@/services/hatsApi/Service'
import { addItem } from '@/mixins/addItem'
import { cloneItem } from '@/mixins/cloneItem'
import { removeItem } from '@/mixins/removeItem'

export default {
  data () {
    return {
      items: {},
      searchQuery: null
    }
  },
  mixins: [addItem, cloneItem, removeItem],
  created () {
    this.type = this.$route.params.type
    Services.getTaxes({query: this.searchQuery}).then((response) => {
      this.items = response.data
    })
  },
  methods: {
    async submit () {
      // Todo: Create record
      let response = await Service.createServiceType(this.items)
      if (response.data.id) {
        this.$router.push({path: '/services/' + this.type + '/' + response.data.id + '/info/tax'})
      }
    },
    submitAndClose () {
      this.submit()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TaxesInputTable.vue